/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { cn } from 'cn'
import useTheme from 'lib/theme/useTheme'

const OpenMobileMenuButton = ({ onClick }: { onClick: () => void }) => {
  const { theme } = useTheme()
  const themedHeader = theme.page.themedBackground

  return (
    <button
      className={cn('rounded-md p-2 inline-flex items-center justify-center', {
        'bg-white text-gray-400 hover:text-gray-500 hover:bg-gray-50 focus:bg-orange-100':
          !themedHeader,
        'bg-transparent hover:opacity-80': themedHeader
      })}
      style={themedHeader ? { color: 'inherit' } : undefined}
      onClick={onClick}
      type="button"
    >
      <span className="sr-only">Open menu</span>
      <svg
        aria-hidden="true"
        className="h-6 w-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 6h16M4 12h16M4 18h16"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </svg>
    </button>
  )
}

export default OpenMobileMenuButton
